import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6a52c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-interactive-block-wrap" }
const _hoisted_2 = { class: "tab-interactive-block" }
const _hoisted_3 = { class: "tab-interactive-block-tabs" }

import {HelpModel, useLocalizationStore} from "@/shared";
import {BlockItemTab} from "@/entities";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tab-interactive-block',
  props: {
  arrData: {
    type: Array<HelpModel>,
    default: Array<HelpModel>(),
  },
  color: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const {translate} = useLocalizationStore();


const getClass = computed(() => {
  return `${props.color} ${props.arrData?.length == 3 ? "col-4" : "col-6"}`;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.arrData, (item, ind) => {
          return (_openBlock(), _createBlock(_unref(BlockItemTab), {
            key: ind,
            class: _normalizeClass(getClass.value),
            image: item.Image,
            text: _unref(translate)(item.Text),
            id: ind,
            scrollHash: item.ScrollHash
          }, null, 8, ["class", "image", "text", "id", "scrollHash"]))
        }), 128))
      ])
    ])
  ]))
}
}

})